import { fromJS } from "immutable";

const CIRCUIT_CATEGORY_NONE = "None";
const CIRCUIT_CATEGORY_NET = "Net";
const CIRCUIT_CATEGORY_LOAD = "Load";
const CIRCUIT_CATEGORY_POWER_GENERATION = "PowerGeneration";
const CIRCUIT_CATEGORY_ENERGY_STORAGE = "EnergyStorage";

const CIRCUIT_CATEGORY_CONTROLLED_LOAD_ONE = "ControlledLoad";
const CIRCUIT_CATEGORY_CONTROLLED_LOAD_TWO = "ControlledLoad2";

const CIRCUIT_CATEGORY_GENERAL_APPLIANCES = "GeneralAppliances";
const CIRCUIT_CATEGORY_LIGHTING = "Lighting";
const CIRCUIT_CATEGORY_HVAC = "Hvac";
const CIRCUIT_CATEGORY_HOT_WATER_SYSTEM = "HotWaterSystem";
const CIRCUIT_CATEGORY_TRANSPORTATION_SYSTEM = "TransportationSystem";
const CIRCUIT_CATEGORY_BUILDING_AUTOMATION = "BuildingAutomation";

const CIRCUIT_CATEGORIES = {
  NONE: CIRCUIT_CATEGORY_NONE,
  NET: CIRCUIT_CATEGORY_NET,
  LOAD: CIRCUIT_CATEGORY_LOAD,
  POWER_GENERATION: CIRCUIT_CATEGORY_POWER_GENERATION,
  ENERGY_STORAGE: CIRCUIT_CATEGORY_ENERGY_STORAGE,
  CONTROLLED_LOAD_ONE: CIRCUIT_CATEGORY_CONTROLLED_LOAD_ONE,
  // CONTROLLED_LOAD_TWO: CIRCUIT_CATEGORY_CONTROLLED_LOAD_TWO,
  GENERAL_APPLIANCES: CIRCUIT_CATEGORY_GENERAL_APPLIANCES,
  LIGHTING: CIRCUIT_CATEGORY_LIGHTING,
  HVAC: CIRCUIT_CATEGORY_HVAC,
  HOT_WATER_SYSTEM: CIRCUIT_CATEGORY_HOT_WATER_SYSTEM,
  TRANSPORTATION_SYSTEM: CIRCUIT_CATEGORY_TRANSPORTATION_SYSTEM,
  BUILDING_AUTOMATION: CIRCUIT_CATEGORY_BUILDING_AUTOMATION
};

const CIRCUIT_CATEGORIES_ARRAY = Object.values(CIRCUIT_CATEGORIES);

const CIRCUIT_CATEGORY_COLORS = {
  NET: "#1565c3",
  LOAD: "#f44336",
  GENERATION: "#2e7d32",
  STORAGE: "#008db1"
};

const CIRCUIT_CATEGORY_LABELS = {
  [CIRCUIT_CATEGORY_GENERAL_APPLIANCES]: "General Appliances",
  [CIRCUIT_CATEGORY_LIGHTING]: "Lighting",
  [CIRCUIT_CATEGORY_HVAC]: "HVAC",
  [CIRCUIT_CATEGORY_HOT_WATER_SYSTEM]: "Hot Water System",
  [CIRCUIT_CATEGORY_TRANSPORTATION_SYSTEM]: "Transportation System",
  [CIRCUIT_CATEGORY_BUILDING_AUTOMATION]: "Building Automation",
  [CIRCUIT_CATEGORY_NET]: "Net",
  [CIRCUIT_CATEGORY_LOAD]: "Load",
  [CIRCUIT_CATEGORY_POWER_GENERATION]: "Power Generation",
  [CIRCUIT_CATEGORY_ENERGY_STORAGE]: "Energy Storage",
  [CIRCUIT_CATEGORY_CONTROLLED_LOAD_ONE]: "Controlled Load"
  // ,
  // [CIRCUIT_CATEGORY_CONTROLLED_LOAD_TWO]: "Controlled Load 2"
};

const circuitCategorySubLevel = [
  { id: CIRCUIT_CATEGORY_GENERAL_APPLIANCES },
  { id: CIRCUIT_CATEGORY_LIGHTING },
  { id: CIRCUIT_CATEGORY_HVAC },
  { id: CIRCUIT_CATEGORY_HOT_WATER_SYSTEM },
  {
    id: CIRCUIT_CATEGORY_TRANSPORTATION_SYSTEM
  },
  { id: CIRCUIT_CATEGORY_BUILDING_AUTOMATION }
].map(opt => {
  opt.label = CIRCUIT_CATEGORY_LABELS[opt.id];
  return opt;
});

const circuitCategories = [
  { id: CIRCUIT_CATEGORY_NET, color: CIRCUIT_CATEGORY_COLORS.NET },
  {
    id: CIRCUIT_CATEGORY_LOAD,
    children: circuitCategorySubLevel,
    color: CIRCUIT_CATEGORY_COLORS.LOAD
  },
  {
    id: CIRCUIT_CATEGORY_POWER_GENERATION,
    color: CIRCUIT_CATEGORY_COLORS.GENERATION
  },
  {
    id: CIRCUIT_CATEGORY_ENERGY_STORAGE,
    color: CIRCUIT_CATEGORY_COLORS.STORAGE
  },
  {
    id: CIRCUIT_CATEGORY_CONTROLLED_LOAD_ONE,
    children: circuitCategorySubLevel,
    color: CIRCUIT_CATEGORY_COLORS.LOAD
  }
  // ,
  // {
  //   id: CIRCUIT_CATEGORY_CONTROLLED_LOAD_TWO,
  //   children: circuitCategorySubLevel,
  //   color: CIRCUIT_CATEGORY_COLORS.LOAD
  // }
].map(opt => {
  opt.label = CIRCUIT_CATEGORY_LABELS[opt.id];
  return opt;
});

const circuitCategoriesList = fromJS(circuitCategories);

export {
  circuitCategoriesList,
  CIRCUIT_CATEGORY_LABELS,
  CIRCUIT_CATEGORIES_ARRAY
};
export default CIRCUIT_CATEGORIES;
